import { Store } from '@ngxs/store';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { GetTranslations, SetDisplayingLanguages, TranslationEditorState } from '../../state';
import { SectionalLanguageList } from '../../../model';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-editor-settings',
  templateUrl: './editor-settings.component.html',
  styleUrls: ['./editor-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LanguageSelectorComponent, MatDialogContent, MatDialogActions, MatIcon],
})
export class EditorSettingsComponent {
  private readonly store = inject(Store);
  private readonly dialogRef = inject<MatDialogRef<EditorSettingsComponent>>(MatDialogRef);

  selectedLanguages: Array<string> = [];
  displayingLanguages = this.store.selectSignal(TranslationEditorState.displayingLanguages);

  onLanguageSelectionChange(languages: SectionalLanguageList): void {
    this.selectedLanguages = Object.keys(languages)
      .map(section => languages[section].map(language => language.lnCode))
      .flat();
  }

  onApplyClick(): void {
    this.store.dispatch([new SetDisplayingLanguages(this.selectedLanguages), new GetTranslations(this.selectedLanguages)]);
    this.onCloseClick();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
